import React from 'react';
import { Text, Stack, getTheme, Icon, TooltipHost } from '@fluentui/react';
import { Stats } from './DashCardBottom';

type DashCardStatProps = Stats;

export const DashCardStat: React.FunctionComponent<DashCardStatProps> = (props: DashCardStatProps) => {
  const { palette } = getTheme();
  const textStyle = { root: { color: palette.neutralDark } };

  return (
    <Stack>
      <Stack horizontal style={{ height: 24 }} tokens={{ childrenGap: 4 }}>
        <Stack.Item>
          <Text variant="large" styles={{ root: { lineHeight: 24 } }}>
            {props.value}
          </Text>
        </Stack.Item>
        {props.hasIcon && (
          <TooltipHost content={props.value + ' ' + props.label} closeDelay={500} calloutProps={{ gapSpace: 0 }}>
            <Icon styles={props.iconStyle} iconName={'Warning12'} aria-hidden="false" />
          </TooltipHost>
        )}
      </Stack>
      <Stack.Item>
        <Text styles={textStyle}>{props.label}</Text>
      </Stack.Item>
    </Stack>
  );
};

export default DashCardStat;
